import React               from "react";
import ReactDOM            from "react-dom";
import App                 from "./bootstrap/App";
import * as serviceWorker  from "./serviceWorker";
import {dispatcher, store} from "./store";
import {SWStatus}          from "./store/slices/system";
import {faInit}            from "./bootstrap/fa";
faInit();

ReactDOM.render(
  <React.StrictMode>
    <App store={store} />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onRegistration: (reg) => {
    if (reg.waiting || reg.installing) {
      dispatcher.system.setStatus(SWStatus.WAITING);
    }
    if (reg.waiting) {
      dispatcher.system.setSW(reg.waiting);
      reg.waiting.postMessage({type: 'SKIP_WAITING'})
    }
  },
  onUpdate: (reg) => {
    if (reg.waiting || reg.installing) {
      dispatcher.system.setStatus(SWStatus.WAITING);
    }
    if (reg.waiting) {
      dispatcher.system.setSW(reg.waiting);
      reg.waiting.postMessage({type: 'SKIP_WAITING'})
    }
  },
  onSuccess: (reg) => {
    dispatcher.system.setStatus(SWStatus.ACTIVE);
    if (reg.waiting) {
      dispatcher.system.setSW(reg.waiting);
      reg.waiting.postMessage({type: 'SKIP_WAITING'})
    }
  },
});
